import React from 'react';
import type { Token } from '@reservoir0x/reservoir-kit-ui';
import clsx from 'clsx';
import {
  type Action,
  QuantityInput,
  type State,
} from '@components/main-components/inputs/QuantityInput';
import { formatWeiToEthDisplayFree } from '@utils/helpers';

export const SecondaryPanel = ({
  state,
  dispatch,
  marketFloorPrice,
  tokens,
  disabled,
}: {
  state: State;
  dispatch: React.Dispatch<Action>;
  marketFloorPrice: string | null;
  tokens: Token[];
  disabled?: boolean;
}) => {
  return (
    <div
      className={clsx(
        'flex items-center justify-between rounded-md p-3 ring-[3px] ring-black md:p-4',
        'cursor-pointer bg-base100 ',
      )}
    >
      <div className="flex flex-col gap-1.5 md:gap-1">
        <div className="flex gap-1.5">
          <h3 className="font-title text-title-s font-medium text-base900 md:text-title-m">
            Secondary
          </h3>
        </div>
        {!!marketFloorPrice && (
          <div className="flex flex-col items-start gap-0.5 font-base text-base-s">
            <div className="flex items-center gap-0.5">
              Floor Price:
              <p className="font-semibold text-base900">
                {formatWeiToEthDisplayFree({
                  weiValue: marketFloorPrice,
                  maxDecimals: 4,
                })}
              </p>
            </div>
          </div>
        )}
      </div>
      <QuantityInput
        key="quantity"
        state={state}
        min={1}
        dispatch={dispatch}
        max={tokens.length}
        disabled={disabled}
      />
    </div>
  );
};
